import { render, staticRenderFns } from "./VrsteSuorganizatora.vue?vue&type=template&id=09128f9f&scoped=true&"
import script from "./VrsteSuorganizatora.vue?vue&type=script&lang=js&"
export * from "./VrsteSuorganizatora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09128f9f",
  null
  
)

export default component.exports